const FORM_MODE = {
  INSERT: ['insert', 'add', 'new'],
  UPDATE: ['update', 'edit'],
  DELETE: ['delete'],
};

const DATE_STRINGS = {
  YEAR: 'year',
  MONTH: 'month',
  DAY: 'day',
};

module.exports = { FORM_MODE, DATE_STRINGS };
